module.exports = __webpack_public_path__ + "static/media/34.bcaa3ea1.mp3";